export const ZiggsLogo = ({ className = "h-12 w-12", ...props }) => (
    <span className={`zf-logo relative block aspect-square ${className}`} {...props}>
        <img
            src="/logo.png"
            alt="Ziggs Forge"
            className="absolute inset-0 h-full w-full object-contain"
            draggable={false}
        />
        <span className="zf-antenna" aria-hidden>
            <img
                src="/logo.png"
                alt=""
                className="absolute inset-0 h-full w-full object-contain"
                draggable={false}
            />
            <span className="zf-glow" />
        </span>
    </span>
);

export default ZiggsLogo;
